import { Box, Button, useTheme } from '@mui/material';
import { ProjectWorkPackage } from './ProjectWorkPackage';
import CardGrid from '../../../cards/layout/CardGrid';
import { tokens } from '../../../../global/theme/tokens';
import { useEffect, useState } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import Cookies from 'universal-cookie';
import { ProjectAddElementButton } from '../ProjectAddElementButton';

const ProjectWorkPackageStack = ({
  phase,
  onPhaseChange,
  editmode,
  project,
  allowedStatuses,
  showOwnWP,
  onEditWP,
  setOpenWPForm,
  handleWorkPackageChange,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const { t } = useTranslation();
  const cookies = new Cookies();
  const userId = Number(cookies.get('userId'));

  const [workPackages, setWorkPackages] = useState([]);

  function handleDelete(itemToDelete) {
    const newWorkPackages = phase.workPackages.filter(
      (obj) => obj.id !== itemToDelete.id
    );
    onPhaseChange({ ...phase, workPackages: newWorkPackages });
  }

  useEffect(() => {
    const sortedWorkPackages = [...(phase?.workPackages ?? [])].sort((a, b) => {
      const aHasDate = !!a.endDate;
      const bHasDate = !!b.endDate;

      if (!aHasDate && !bHasDate) return 0; // both missing → keep order
      if (!aHasDate) return 1; // a missing → goes after b
      if (!bHasDate) return -1; // b missing → goes after a

      return moment(a.endDate).valueOf() - moment(b.endDate).valueOf();
    });

    setWorkPackages(sortedWorkPackages);
  }, [phase?.workPackages]);

  // if (!editmode && phase.workPackages && !phase.workPackages.length) return;
  return (
    <CardGrid className="px-4 py-4 shadow-lg">
      {workPackages
        .filter(
          (wp) =>
            allowedStatuses.includes(wp.status) && //Filter by selected statuses AND
            (!showOwnWP || wp.users?.some((u) => Number(u.id) === userId)) // (if enabled) only show work packages containing the current user
        )
        .map((workPackage) => (
          <ProjectWorkPackage
            project={project}
            key={workPackage.id}
            workPackage={workPackage}
            onChange={handleWorkPackageChange}
            onDelete={handleDelete}
            editmode={editmode}
            onEdit={(wp) => {
              onEditWP(wp);
              setOpenWPForm(true);
            }}
          />
        ))}

      {editmode && (
        <ProjectAddElementButton
          className="add-wp backdrop-blur-lg"
          onClick={() => setOpenWPForm(true)}
        />
      )}
    </CardGrid>
  );
};

export default ProjectWorkPackageStack;
